import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'activate.account.page.title': {
    id: 'activate.account.page.title',
    defaultMessage: 'Activate Account',
    description: 'activate account page title',
  },
  'activate.account.page.status.text': {
    id: 'activate.account.page.status.text',
    defaultMessage: 'You are almost there !',
    description: 'activate account page status text',
  },
  'activate.account.page.strongpassword.info.text': {
    id: 'activate.account.page.strongpassword.info.text',
    defaultMessage:
      'Please choose a {strong} to secure your account.',
    description: 'informing users to choose strong password info text',
  },
  'activate.account.page.password.credentials.info.text': {
    id: 'activate.account.page.password.credentials.info.text',
    defaultMessage:
      'Your password should be at least {minPassLength} characters long, with a mix of letters, numbers, and special characters',
    description: 'informing users to choose password with right credentials',
  },
  'activate.account.setpassword.button.text': {
    id: 'activate.account.setpassword.button.text',
    defaultMessage: 'Set my password',
    description: 'The button text for set the password.',
  },

  'activate.account.password.label': {
    id: 'activate.account.password.label',
    defaultMessage: 'Password',
    description: 'Label for password field',
  },
  'activate.account.confirm.password.label': {
    id: 'activate.account.confirm.password.label',
    defaultMessage: 'Confirm Password',
    description: 'Label for confirm password field',
  },
});

export default messages;
